import { render, staticRenderFns } from "./AppInfoItem.vue?vue&type=template&id=5d8d03f5&scoped=true"
import script from "./AppInfoItem.vue?vue&type=script&lang=js"
export * from "./AppInfoItem.vue?vue&type=script&lang=js"
import style0 from "./AppInfoItem.vue?vue&type=style&index=0&id=5d8d03f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d03f5",
  null
  
)

export default component.exports